import fetcher from 'api/fetcher';
import type { AxiosError } from 'axios';
import {
    CampaignType,
    ERROR_VACANCY_BANNER_LINK_MAGRITTE_NOTIFICATION_MAP,
    VacancyError,
} from 'utils/constants/campaign';
import { MagritteNotificationName } from 'utils/constants/notification';

import { setBannerVacancyId } from 'store/models/createBanner';
import { setCampaignType } from 'store/models/createCampaign';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

interface BannerLinkCheck {
    vacancyId: number | null;
    advertisingServiceType: CampaignType;
}

export const getCampaignType = (): AppThunkAction<Promise<void> | null> => {
    return (dispatch, getState) => {
        const { bannerVacancyId, bannerLink } = getState().createBanner;

        if (!bannerLink && !bannerVacancyId) {
            return null;
        }

        if (bannerVacancyId) {
            dispatch(setCampaignType(CampaignType.Information));
            return null;
        }

        return fetcher
            .put<unknown, BannerLinkCheck>('/api/v1/campaigns/advertising_service_type_extended', { url: bannerLink })
            .then(({ vacancyId, advertisingServiceType }) => {
                dispatch((dispatch) => {
                    dispatch(setCampaignType(advertisingServiceType));
                    dispatch(setBannerVacancyId(vacancyId));
                });
            })
            .catch(
                (
                    err: AxiosError<{
                        errors: { key: VacancyError }[];
                    }>
                ) => {
                    dispatch(setCampaignType(null));

                    const defaultNotification = MagritteNotificationName.SomethingWentWrong;
                    if (err?.response?.status === 400) {
                        dispatch(
                            addMagritteNotification(
                                ERROR_VACANCY_BANNER_LINK_MAGRITTE_NOTIFICATION_MAP[
                                    err.response.data.errors?.[0].key
                                ] || defaultNotification
                            )
                        );
                        return;
                    }
                    if (err?.response?.status === 403) {
                        dispatch(addMagritteNotification(MagritteNotificationName.ErrorAccessInBannerLink));
                        return;
                    }
                    dispatch(addMagritteNotification(defaultNotification));
                }
            );
    };
};
